// src/pages/xray/XrayLobby/TabVLANs.js
import React from 'react';

const TabVLANs = ({
  selectedTabsVLANs,
  setSelectedTabsVLANs,
  defaultVLAN,
  voiceVLAN,
  membersVLAN,
  tagVLAN,
  vlanNetworks,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {[
          'Default VLAN',
          'Voice VLAN',
          'members of VLAN[x]',
          'TAG/UNTAG',
          'VLAN Networks',
        ].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsVLANs === `tabsVLANs${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedTabsVLANs === `tabsVLANs${index + 1}`}
              onChange={() => setSelectedTabsVLANs(`tabsVLANs${index + 1}`)}
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsVLANs === 'tabsVLANs1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              Default VLAN and its correspondent LAN IP
            </h1>
            <div className="bg-gray-100 p-4 rounded-md border font-mono text-sm whitespace-pre-wrap">
              {defaultVLAN && defaultVLAN.length > 0
                ? defaultVLAN.map((line, idx) => {
                    const parts = line.split('=');
                    return (
                      <div key={idx}>
                        {parts[0].startsWith('DEFAULT_VLAN_ID') ? (
                          <>
                            <span className="font-bold text-yellow-600">
                              {parts[0]}=
                            </span>
                            <span className="font-bold text-lg">
                              {parts.slice(1).join('=')}
                            </span>
                          </>
                        ) : (
                          line
                        )}
                      </div>
                    );
                  })
                : 'No Default VLAN available'}
            </div>
          </div>
        )}

        {selectedTabsVLANs === 'tabsVLANs2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">Voice VLAN</h1>
            <p className="pl-2 pb-2">
              The IP Address assigned to the subinterface ETH0.XXX of the{' '}
              <b>Voice VLAN</b> is used in Broadsoft inside the{' '}
              <b>REGSERVER-1</b> tag, either at group level or on a particular
              device.
            </p>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {voiceVLAN || 'No Voice VLAN available'}
            </pre>
          </div>
        )}

        {selectedTabsVLANs === 'tabsVLANs3' && (
          <div>
            <h1 className="font-bold text-2xl p-2">VLAN[x] members</h1>
            <p className="pl-2 pb-2">Effectively assigned VLANs to ports</p>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {membersVLAN || 'No VLAN members available'}
            </pre>
          </div>
        )}

        {selectedTabsVLANs === 'tabsVLANs4' && (
          <div>
            <h1 className="font-bold text-2xl p-2">VLAN Ports TAG/UNTAG</h1>
            <p className="pl-2 pb-2">
              Ports with no VLAN assigned will get the Default VLAN.
            </p>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {tagVLAN || 'No VLAN TAG/UNTAG data available'}
            </pre>
          </div>
        )}

        {selectedTabsVLANs === 'tabsVLANs5' && (
          <div>
            <h1 className="font-bold text-2xl p-2">VLAN Networks</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {vlanNetworks || 'No VLAN Networks available'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabVLANs;
